<template>
  <div class="mElectronicFooter">
    <el-button class="button" :size="size" v-if="step > 1" @click="back"
      >上一步</el-button
    >
    <el-button class="button" v-else :size="size" @click="close">取消</el-button>
    <el-button
      class="button"
      type="primary"
      :size="size"
      @click="nextClick"
      :disabled="disabledNext"
      >下一步</el-button
    >
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    hidBack: {
      type: Boolean,
      default: false,
    },
    disabledNext: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      size: "small",
    };
  },
  created() {},
  computed: {
    ...mapState("hetongqianshu", ["step"]),
  },
  methods: {
    ...mapActions("hetongqianshu", ["setStep"]),
    next() {
      this.setStep(this.step + 1);
    },
    back() {
      this.setStep(this.step - 1);
    },
    close() {
      this.$alert("退出将会丢失已录入信息，确定退出吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
        callback: (action) => {
          if (action !== "confirm") {
            return;
          }
          this.$store.dispatch("hetongqianshu/clearData",{type:'toHome'});
          // this.$router.replace("/home");
        },
      });
    },
    nextClick() {
      this.$emit("nextClick");
    },
  },
};
</script>

<style scoped lang="scss">
.mElectronicFooter {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  justify-content: flex-end;
  .button {
    @include buttonStyle;
  }
}
</style>
